/*
 * Velour — PDP galeri + lightbox.
 * - Masaüstü: thumbnail tıklayınca ana görsel değişir (is-active).
 * - Mobil: scroll-snap pozisyonuna göre nokta + sayaç güncellenir.
 * - Lightbox: görsele tıkla → fullscreen; prev/next, ESC, kapat, sayaç.
 * Tek custom element; global scope kirletmez. Theme editor uyumlu.
 */
(function () {
  'use strict';

  if (customElements.get('media-gallery-vl')) return;

  class MediaGalleryVl extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-vl-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-vl-gallery-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-vl-thumb]'));
      this.dots = Array.from(this.querySelectorAll('[data-vl-dot]'));
      this.counter = this.querySelector('[data-vl-gallery-counter]');
      this.lightbox = this.querySelector('[data-vl-lightbox]');
      this.prevBtn = this.querySelector('[data-vl-gallery-prev]');
      this.nextBtn = this.querySelector('[data-vl-gallery-next]');
      this.layout = this.getAttribute('data-vl-layout') || 'thumbs';
      this.current = 0;
      this.isDesktop = window.matchMedia('(min-width: 990px)').matches;

      // Tek-aktif-görsel modu yalnızca masaüstü "thumbs" düzeninde geçerli.
      // grid/stacked: tüm görseller görünür (CSS). carousel: track kayar.
      this.singleActive = this.layout === 'thumbs';

      if (this.slides.length && this.isDesktop && this.singleActive) {
        this.slides[0].classList.add('is-active');
      }

      this.bindThumbs();
      this.bindArrows();
      this.bindMobileScroll();
      this.bindLightbox();

      this._onResize = this.onResize.bind(this);
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('keydown', this._onKeydown);
    }

    onResize() {
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      if (desktop === this.isDesktop) return;
      this.isDesktop = desktop;
      this.setActive(this.current);
    }

    /* ---------- Masaüstü thumbnail ---------- */
    bindThumbs() {
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = parseInt(thumb.getAttribute('data-vl-thumb'), 10) || 0;
          this.setActive(index);
          if (!this.isDesktop) this.scrollToSlide(index);
        });
      });
    }

    /* ---------- Prev / next oklar (carousel + tüm düzenler) ---------- */
    bindArrows() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
    }

    step(dir) {
      const len = this.slides.length;
      if (!len) return;
      const next = (this.current + dir + len) % len;
      this.setActive(next);
      // Kayan track varsa (mobil her zaman, masaüstü carousel) ona da kaydır.
      if (!this.isDesktop || this.layout === 'carousel') this.scrollToSlide(next);
    }

    setActive(index) {
      this.current = index;

      if (this.isDesktop && this.singleActive) {
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === index);
        });
      }

      this.thumbs.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      this.updateCounter();
    }

    updateCounter() {
      if (this.counter) {
        this.counter.textContent = this.current + 1 + ' / ' + this.slides.length;
      }
    }

    scrollToSlide(index) {
      const slide = this.slides[index];
      if (slide && this.track) {
        this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
    }

    /* ---------- Mobil scroll ---------- */
    bindMobileScroll() {
      if (!this.track) return;
      let raf = null;
      this.track.addEventListener('scroll', () => {
        if (raf) return;
        raf = window.requestAnimationFrame(() => {
          raf = null;
          // Masaüstünde sadece carousel düzeninde track kayar; thumbs/grid/stacked'te değil.
          if (this.isDesktop && this.layout !== 'carousel') return;
          const width = this.track.clientWidth || 1;
          const index = Math.round(this.track.scrollLeft / width);
          if (index !== this.current) {
            this.current = Math.max(0, Math.min(index, this.slides.length - 1));
            this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));
            this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === this.current));
            this.updateCounter();
          }
        });
      });
    }

    /* ---------- Lightbox ---------- */
    bindLightbox() {
      if (!this.lightbox) return;

      const dataNode = this.querySelector('[data-vl-gallery-data]');
      try {
        this.media = dataNode ? JSON.parse(dataNode.textContent) : [];
      } catch (err) {
        this.media = [];
      }

      this.stage = this.lightbox.querySelector('[data-vl-lightbox-stage]');
      this.lbCounter = this.lightbox.querySelector('[data-vl-lightbox-counter]');
      const prevBtn = this.lightbox.querySelector('[data-vl-lightbox-prev]');
      const nextBtn = this.lightbox.querySelector('[data-vl-lightbox-next]');

      this.lbIndex = 0;
      this.lastFocus = null;

      this.querySelectorAll('[data-vl-zoom-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const index = parseInt(trigger.getAttribute('data-vl-zoom-trigger'), 10) || 0;
          this.openLightbox(index);
        });
      });

      if (prevBtn) prevBtn.addEventListener('click', (e) => { e.stopPropagation(); this.lbStep(-1); });
      if (nextBtn) nextBtn.addEventListener('click', (e) => { e.stopPropagation(); this.lbStep(1); });

      // KAPATMA: görsel ve ok butonları DIŞINDA her yere tıklayınca kapat.
      // (.vl-lightbox__inner tüm ekranı kapladığı için eski "sadece overlay/X"
      // yaklaşımı çalışmıyordu → kullanıcı kapatamayıp donma yaşıyordu.)
      this.lightbox.addEventListener('click', (e) => {
        if (e.target.closest('[data-vl-lightbox-prev]') || e.target.closest('[data-vl-lightbox-next]')) return;
        if (e.target.closest('[data-vl-lightbox-stage] img')) return;
        this.closeLightbox();
      });

      this._onKeydown = (e) => {
        if (this.lightbox.hidden) return;
        if (e.key === 'Escape') this.closeLightbox();
        else if (e.key === 'ArrowRight') this.lbStep(1);
        else if (e.key === 'ArrowLeft') this.lbStep(-1);
      };
      document.addEventListener('keydown', this._onKeydown);
    }

    renderLightbox(index) {
      if (!this.media[index] || !this.stage) return;
      const item = this.media[index];
      this.stage.innerHTML = '';
      const img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt || '';
      img.draggable = false;
      this.stage.appendChild(img);
      this.lbIndex = index;
      if (this.lbCounter) this.lbCounter.textContent = index + 1 + ' / ' + this.media.length;
    }

    openLightbox(index) {
      if (!this.media.length) return;
      this.lastFocus = document.activeElement;
      this.lightbox.hidden = false;
      // force reflow for transition
      void this.lightbox.offsetWidth;
      this.lightbox.setAttribute('data-open', '');
      this.lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('vl-no-scroll');
      this.renderLightbox(index || 0);
      const closeBtn = this.lightbox.querySelector('[data-vl-lightbox-close]');
      if (closeBtn && closeBtn.focus) closeBtn.focus();
    }

    closeLightbox() {
      this.lightbox.removeAttribute('data-open');
      this.lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('vl-no-scroll');
      window.setTimeout(() => {
        this.lightbox.hidden = true;
        if (this.stage) this.stage.innerHTML = '';
      }, 280);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    lbStep(dir) {
      const len = this.media.length;
      if (!len) return;
      this.renderLightbox((this.lbIndex + dir + len) % len);
    }
  }

  customElements.define('media-gallery-vl', MediaGalleryVl);
})();
